import * as URI from 'urijs';
import { MediaType, MediaDocument } from '../../media-document.model';
import { ICONOCLAST_URL } from '../content-document-adapter.config';

export class ContentDocumentDefaultAdapter {
    static toContentDocument(document: any): MediaDocument {
        let contentDocument = new MediaDocument(document);
        let author = document.authors && document.authors[0] ? document.authors[0] : {};

        contentDocument.documentId = document.documentId;
        contentDocument.isHosted = document.isHosted;
        contentDocument.authors = document.authors;
        contentDocument.date = document.date;
        contentDocument.dupDocs = [];
        contentDocument.dupDocsCount = document.dupDocsCount;
        contentDocument.dupDocsIdsRemaining = document.remainingDupDocsIds;
        contentDocument.keywords = document.keywords || document.tagContextKeywords;
        contentDocument.matchSentences = [document.matchSentence || document.tagContextMatchSentence || document.body];
        contentDocument.mediaType = document.mediaType;
        contentDocument.mediaTypeIcon = document.mediaTypeIcon || contentDocument.mediaType;
        contentDocument.mediaImageUrl = (document.images && document.images[0]) ? document.images[0].link : '';
        contentDocument.provider = document.provider;
        contentDocument.sentiment = document.isSentimentModified ? document.originalSentiment : document.sentiment;
        contentDocument.sentimentOverride = document.isSentimentModified ? document.sentiment : '';
        contentDocument.sourceAvatarRounded = true;
        contentDocument.sourceAvatarImgUrl = author.avatarUrl ? document.authors[0].avatarUrl : `${ICONOCLAST_URL}/favicon?size=48&url=${new URI(document.sourceUrl).origin()}`;
        contentDocument.sourceAvatarLinkUrl = document.sourceUrl;
        contentDocument.sourceCountryCode = document.country || document.countryCode;
        contentDocument.sourceName = document.source || 'Unknown';
        contentDocument.sourceNameUrl = document.sourceUrl;
        contentDocument.tags = document.tags;
        contentDocument.title = document.title;
        contentDocument.language = document.language;
        contentDocument.url = document.url || document.redirectUrl;
        contentDocument.titleUrl = contentDocument.url;

        // TODO: not sure if we should bake in support for these but putting them in for now
        contentDocument.reachCount = document.reach;
        contentDocument.potentialReach = document.potentialReach;

        return contentDocument;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/adapter/adapters/content-document-default.adapter.ts